import axios from "axios";
import env from "../variables/config";

axios.defaults.baseURL = env.apiUrl;
const config = () => ({ headers: { Authorization: `Bearer ${localStorage.getItem("token")}` } });

export type EnrichmentStatusValue =
    | "pending" | "processing" | "waiting_callback" | "done" | "approved"
    | "error" | "rejected" | "retry" | "closed" | "unsure";

export interface EnrichmentEntry {
    type: string;
    status: EnrichmentStatusValue;
    lastRunAt: string | null;
    reviewedAt: string | null;
    isManuallyReviewed: boolean;
    error: string | null;
    retryCount: number;
    aiConfidenceLevel: string | null;
    appliedToEstablishment: boolean | null;
    appliedPaths: string[];
    blockedReason: string | null;
    blockedAt: string | null;
    optionsCount: number;
    dataPreview: string | null;
}

export interface EnrichmentPerson {
    _id: string;
    name: string;
    qualite: string | null;
    role: string;
    enrichments: EnrichmentEntry[];
}

export interface EnrichmentEvent {
    _id: string;
    companyName: string;
    source: string;
    eventType: string | null;
    detectedAt: string | null;
    createdAt: string | null;
    stage: string | null;
    naf_code: string | null;
    enrichments: EnrichmentEntry[];
    notStarted: string[];
    people: EnrichmentPerson[];
}

export interface EstablishmentEnrichmentsResponse {
    establishment: {
        _id: string;
        name: string;
        legal_name?: string;
        address?: { street?: string; city?: string; postcode?: string };
        registration?: { siret?: string; siren?: string };
        operations?: { opening_date?: string };
        createdAt?: string;
    };
    matchedBy: "siret" | "siren" | null;
    events: EnrichmentEvent[];
    rules: { type: string; targetModel: "Event" | "Person"; enabled: boolean; description: string | null }[];
}

export const getEstablishmentEnrichments = async (id: string): Promise<EstablishmentEnrichmentsResponse> => {
    const res = await axios.get(`/admin/establishments/${id}/enrichments`, config());
    return res.data;
};
